function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 82,
    viewBox: "0 0 616 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M111.798 14.5145H130.025C140.976 14.5145 147.076 19.5122 147.076 27.8173C147.076 33.844 143.842 37.9598 137.889 39.5032C144.43 40.7527 149.207 44.207 149.207 51.7771C149.207 60.4497 142.74 65.9619 130.539 65.9619H111.798V14.5145ZM118.192 20.3207V36.8573H130.319C136.934 36.8573 140.682 33.7705 140.682 28.5523C140.682 23.4075 137.007 20.3207 130.319 20.3207H118.192ZM118.192 42.5901V60.1557H130.539C138.477 60.1557 142.666 56.8483 142.666 51.5566C142.666 45.7504 138.183 42.5901 130.539 42.5901H118.192Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.768 14.5145H159.794V65.9619H153.768V14.5145Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.349 28.4788H197.376V65.9619H192.157L191.349 60.9641C189.144 63.757 185.543 66.4029 179.369 66.4029C171.137 66.4029 164.596 61.7726 164.596 49.3517V28.4788H170.623V48.9842C170.623 56.7748 174.151 60.8906 180.398 60.8906C187.233 60.8906 191.349 55.6724 191.349 47.2203V28.4788Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.328 47.2203C201.328 35.6814 208.531 28.0378 219.114 28.0378C229.404 28.0378 236.607 34.726 236.901 45.8239C236.901 46.6324 236.827 47.5143 236.754 48.3963H207.649V48.9107C207.87 56.1869 212.5 61.0376 219.482 61.0376C224.774 61.0376 228.889 58.2448 230.139 53.394H236.239C234.769 60.8906 228.595 66.4029 219.923 66.4029C208.678 66.4029 201.328 58.6858 201.328 47.2203ZM208.017 43.3985H230.653C230.065 36.9308 225.435 33.3295 219.188 33.3295C213.676 33.3295 208.604 37.2983 208.017 43.3985Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.726 28.0378C270.089 28.0378 277.733 35.0199 277.733 47.2203C277.733 58.6858 270.089 66.4029 259.726 66.4029C253.406 66.4029 249.143 63.8305 246.864 60.2292V80.6611H240.838V28.4788H246.056L246.864 34.5055C249.363 31.0511 253.406 28.0378 259.726 28.0378ZM259.138 61.0376C266.561 61.0376 271.559 55.3784 271.559 47.2203C271.559 39.0622 266.561 33.403 259.138 33.403C251.789 33.403 246.791 39.0622 246.791 47.0733C246.791 55.3049 251.789 61.0376 259.138 61.0376Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.025 28.4788H300.715V34.3585H297.702C289.838 34.3585 287.707 40.8996 287.707 46.8528V65.9619H281.68V28.4788H286.898L287.707 34.138C289.47 31.2716 292.337 28.4788 299.025 28.4788Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3 14C308.505 14 310.195 15.6169 310.195 17.8953C310.195 20.1737 308.505 21.7906 306.3 21.7906C304.095 21.7906 302.405 20.1737 302.405 17.8953C302.405 15.6169 304.095 14 306.3 14ZM303.287 28.4788H309.313V65.9619H303.287V28.4788Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.004 28.0378C341.456 28.0378 348.144 32.6681 348.144 45.0889V65.9619H342.117V45.4564C342.117 37.6658 338.516 33.55 331.975 33.55C324.919 33.55 320.656 38.7683 320.656 47.2203V65.9619H314.63V28.4788H319.848L320.656 33.55C322.861 30.6837 326.683 28.0378 333.004 28.0378Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3 56.1869V17.9688H358.327V28.4788H367.808V33.991H358.327V56.1134C358.327 59.2737 359.429 60.4497 362.443 60.4497H368.984V65.9619H362.075C354.872 65.9619 352.3 62.8015 352.3 56.1869Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.998 14.5145H416.969V20.3942H391.392V37.5923H412.559V43.472H391.392V65.9619H384.998V14.5145Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.019 14C425.224 14 426.914 15.6169 426.914 17.8953C426.914 20.1737 425.224 21.7906 423.019 21.7906C420.814 21.7906 419.124 20.1737 419.124 17.8953C419.124 15.6169 420.814 14 423.019 14ZM420.006 28.4788H426.032V65.9619H420.006V28.4788Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.723 28.0378C458.175 28.0378 464.863 32.6681 464.863 45.0889V65.9619H458.836V45.4564C458.836 37.6658 455.235 33.55 448.694 33.55C441.638 33.55 437.375 38.7683 437.375 47.2203V65.9619H431.349V28.4788H436.567L437.375 33.55C439.58 30.6837 443.402 28.0378 449.723 28.0378Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.827 60.4497H504.665V65.9619H501.357C496.36 65.9619 494.669 63.8305 494.596 60.1557C492.244 63.5365 488.496 66.4029 482.028 66.4029C473.796 66.4029 468.211 62.2871 468.211 55.4519C468.211 47.9553 473.429 43.766 483.277 43.766H494.302V41.1936C494.302 36.3429 490.847 33.403 484.968 33.403C479.676 33.403 476.148 35.9019 475.413 39.7237H469.386C470.268 32.3741 476.222 28.0378 485.262 28.0378C494.816 28.0378 500.328 32.8151 500.328 41.5611V57.7303C500.328 59.5677 501.284 60.4497 502.827 60.4497ZM494.302 50.6747V48.8372H482.689C477.324 48.8372 474.311 50.8216 474.311 55.0844C474.311 58.7592 477.471 61.2581 482.469 61.2581C489.965 61.2581 494.302 56.9218 494.302 50.6747Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.732 28.0378C533.184 28.0378 539.872 32.6681 539.872 45.0889V65.9619H533.846V45.4564C533.846 37.6658 530.244 33.55 523.703 33.55C516.647 33.55 512.385 38.7683 512.385 47.2203V65.9619H506.358V28.4788H511.576L512.385 33.55C514.59 30.6837 518.411 28.0378 524.732 28.0378Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.057 53.0265C576.514 61.2581 570.487 66.4029 561.52 66.4029C550.569 66.4029 543.293 58.6123 543.293 47.1468C543.293 35.6814 550.716 28.0378 561.741 28.0378C570.707 28.0378 576.587 33.1825 578.057 41.2671H571.957C570.781 36.4899 566.886 33.403 561.52 33.403C554.318 33.403 549.467 38.9887 549.467 47.1468C549.467 55.3049 554.318 61.0376 561.52 61.0376C567.033 61.0376 570.928 57.9508 572.03 53.0265H578.057Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.973 47.2203C579.973 35.6814 587.175 28.0378 597.759 28.0378C608.048 28.0378 615.251 34.726 615.545 45.8239C615.545 46.6324 615.471 47.5143 615.398 48.3963H586.293V48.9107C586.514 56.1869 591.144 61.0376 598.126 61.0376C603.418 61.0376 607.534 58.2448 608.783 53.394H614.883C613.413 60.8906 607.24 66.4029 598.567 66.4029C587.322 66.4029 579.973 58.6858 579.973 47.2203ZM586.661 43.3985H609.298C608.71 36.9308 604.079 33.3295 597.832 33.3295C592.32 33.3295 587.249 37.2983 586.661 43.3985Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7665 10.0614C44.7665 4.50467 49.2712 0 54.828 0H83V28.172C83 33.7288 78.4953 38.2334 72.9386 38.2334H54.828C49.2712 38.2334 44.7665 33.7288 44.7665 28.172V10.0614Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.496277 0H28.6683C34.2251 0 38.7297 4.50466 38.7297 10.0614V28.172C38.7297 33.7288 34.2251 38.2334 28.6683 38.2334H10.5577C5.00094 38.2334 0.496277 33.7288 0.496277 28.172V0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7665 53.3256C44.7665 47.7688 49.2712 43.2642 54.828 43.2642H72.9385C78.4953 43.2642 83 47.7688 83 53.3256V81.4976H54.828C49.2712 81.4976 44.7665 76.9929 44.7665 71.4362V53.3256Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.496277 53.3256C0.496277 47.7688 5.00093 43.2642 10.5577 43.2642H28.6683C34.2251 43.2642 38.7297 47.7688 38.7297 53.3256V71.4362C38.7297 76.9929 34.2251 81.4976 28.6683 81.4976H0.496277V53.3256Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo-3.fca956bea6ed85663931aacf09fd6254.svg";
export { ForwardRef as ReactComponent };